import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'unsuccessful-change-review';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Unsuccessful Change Review',
};

const unsuccessfulChangeReview = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { unsuccessfulChangeReview };
